import { RELEASE_TYPES } from '@anghami/neogateway/dist/endpoints/getreleasedetails';
import { FeaturedTypes } from 'components/Featured/Interfaces/featured.interface';

export interface IParsedAnghamiUrl {
  id: string;
  type: 'album' | 'song' | 'playlist';
  releaseType?: RELEASE_TYPES;
  featuredType?: FeaturedTypes;
}

export const parseAnghamiUrl = (url: string): IParsedAnghamiUrl | null => {
  try {
    const urlPatterns = [
      /https?:\/\/play\.anghami\.com\/(album|song|playlist)\/(\d+)/i,
      /https?:\/\/anghami\.com\/(album|song|playlist)\/(\d+)/i,
      /https?:\/\/www\.anghami\.com\/(album|song|playlist)\/(\d+)/i
    ];

    for (const pattern of urlPatterns) {
      const match = url.match(pattern);
      if (match) {
        const [, type, id] = match;
        const normalizedType = type.toLowerCase() as 'album' | 'song' | 'playlist';

        return {
          id,
          type: normalizedType,
          releaseType: getReleaseTypeFromUrlType(normalizedType),
          featuredType: getFeaturedTypeFromUrlType(normalizedType)
        };
      }
    }

    return null;
  } catch (error) {
    console.error('Error parsing Anghami URL:', error);
    return null;
  }
};

const getReleaseTypeFromUrlType = (urlType: string): RELEASE_TYPES | undefined => {
  switch (urlType) {
    case 'album':
      return RELEASE_TYPES.Album;
    case 'song':
      return RELEASE_TYPES.Single;
    case 'playlist':
      return undefined;
    default:
      return undefined;
  }
};

const getFeaturedTypeFromUrlType = (urlType: string): FeaturedTypes | undefined => {
  switch (urlType) {
    case 'album':
      return FeaturedTypes.albums;
    case 'song':
      return FeaturedTypes.songs;
    case 'playlist':
      return FeaturedTypes.playlists;
    default:
      return undefined;
  }
};
